import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import { RootState } from '../store/store';

const PrivateRoute: React.FC = () => {
  const { userGlobalData } = useSelector((state: RootState) => state.dreamworld);

  return userGlobalData ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
